import { render, staticRenderFns } from "./mainMenu.vue?vue&type=template&id=d0897690&scoped=true&"
import script from "./mainMenu.vue?vue&type=script&lang=js&"
export * from "./mainMenu.vue?vue&type=script&lang=js&"
import style0 from "./mainMenu.vue?vue&type=style&index=0&id=d0897690&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0897690",
  null
  
)

export default component.exports